import { GAME_ID, REDUX_ACTIONS } from 'a/cutItOut/data/constants';
import CurriculumManager from 'a/cutItOut/content/CurriculumManager';

export const initialState = {
  initialAnimal: {
    head: null,
    body: null,
    tail: null,
  },
  head: null,
  body: null,
  tail: null,
  headList: [],
  bodyList: [],
  tailList: [],
  selectedSection: null,
  interactionLocked: false,
  modalIsVisible: false,
  pulsingTokensCounter: {
    interval: 0,
    duration: 0,
    id: null,
  },
  pulsingSubmitButton: {
    interval: 0,
    duration: 0,
    isPulsing: false,
  },
};

const bonusGameReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_BONUS_LEVEL: {
      const animal = CurriculumManager.getBonusLevelAnimal();

      return {
        ...initialState,
        initialAnimal: {
          head: animal.head,
          body: animal.body,
          tail: animal.tail,
        },
        head: animal.head,
        body: animal.body,
        tail: animal.tail,
        headList: CurriculumManager.getBonusLevelHeadList(
          animal.head,
          action.payload.headTokens,
        ),
        bodyList: CurriculumManager.getBonusLevelBodyList(
          animal.body,
          action.payload.bodyTokens,
        ),
        tailList: CurriculumManager.getBonusLevelTailList(
          animal.tail,
          action.payload.tailTokens,
        ),
      };
    }
    case REDUX_ACTIONS.SET_ANIMAL_HEAD:
      return {
        ...state,
        head: action.payload.head,
      };
    case REDUX_ACTIONS.SET_ANIMAL_BODY:
      return {
        ...state,
        body: action.payload.body,
      };
    case REDUX_ACTIONS.SET_ANIMAL_TAIL:
      return {
        ...state,
        tail: action.payload.tail,
      };
    case REDUX_ACTIONS.SET_SELECTED_SECTION:
      return {
        ...state,
        selectedSection: action.payload.selectedSection,
      };
    case REDUX_ACTIONS.SET_INTERACTION_LOCKED:
      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
    case REDUX_ACTIONS.SET_MODAL_VISIBLE:
      return {
        ...state,
        modalIsVisible: action.payload.modalIsVisible,
      };
    case REDUX_ACTIONS.SET_PULSING_TOKENS_COUNTER:
      return {
        ...state,
        pulsingTokensCounter: {
          id: action.payload.id,
          duration: action.payload.duration,
          interval: action.payload.interval,
        },
      };
    case REDUX_ACTIONS.SET_PULSING_SUBMIT_BUTTON:
      return {
        ...state,
        pulsingSubmitButton: {
          isPulsing: action.payload.isPulsing,
          duration: action.payload.duration,
          interval: action.payload.interval,
        },
      };
    case REDUX_ACTIONS.SET_PULSE_FINISHED:
      return {
        ...state,
        pulsingTokensCounter: initialState.pulsingTokensCounter,
      };
    default:
      return state;
  }
};

export default bonusGameReducer;
